module.exports = __webpack_public_path__ + "img/变速箱.96864f38.jpg";